module.exports = __webpack_public_path__ + "static/media/om_hairstyle_wavy_front.8b42ceaf.png";